import * as mainTerms from '../mainTerms';
const creative = mainTerms.Other.creative;

export const img = {
    ad: {
        modalZoom: {
            alt: creative + ' 확대',
        },
    },
}